var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1669_5228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 14.0625H1.40625C0.62959 14.0625 0 13.4329 0 12.6562V2.34375C0 1.56709 0.62959 0.9375 1.40625 0.9375H13.5938C14.3704 0.9375 15 1.56709 15 2.34375V12.6562C15 13.4329 14.3704 14.0625 13.5938 14.0625ZM3.75 3.51562C3.1028 3.51562 2.57812 4.0403 2.57812 4.6875C2.57812 5.3347 3.1028 5.85938 3.75 5.85938C4.3972 5.85938 4.92188 5.3347 4.92188 4.6875C4.92188 4.0403 4.3972 3.51562 3.75 3.51562ZM3.75 6.32812C3.1028 6.32812 2.57812 6.8528 2.57812 7.5C2.57812 8.1472 3.1028 8.67188 3.75 8.67188C4.3972 8.67188 4.92188 8.1472 4.92188 7.5C4.92188 6.8528 4.3972 6.32812 3.75 6.32812ZM3.75 9.14062C3.1028 9.14062 2.57812 9.6653 2.57812 10.3125C2.57812 10.9597 3.1028 11.4844 3.75 11.4844C4.3972 11.4844 4.92188 10.9597 4.92188 10.3125C4.92188 9.6653 4.3972 9.14062 3.75 9.14062ZM12.1875 5.15625V4.21875C12.1875 4.0246 12.0301 3.86719 11.8359 3.86719H5.97656C5.78241 3.86719 5.625 4.0246 5.625 4.21875V5.15625C5.625 5.3504 5.78241 5.50781 5.97656 5.50781H11.8359C12.0301 5.50781 12.1875 5.3504 12.1875 5.15625ZM12.1875 7.96875V7.03125C12.1875 6.8371 12.0301 6.67969 11.8359 6.67969H5.97656C5.78241 6.67969 5.625 6.8371 5.625 7.03125V7.96875C5.625 8.1629 5.78241 8.32031 5.97656 8.32031H11.8359C12.0301 8.32031 12.1875 8.1629 12.1875 7.96875ZM12.1875 10.7812V9.84375C12.1875 9.6496 12.0301 9.49219 11.8359 9.49219H5.97656C5.78241 9.49219 5.625 9.6496 5.625 9.84375V10.7812C5.625 10.9754 5.78241 11.1328 5.97656 11.1328H11.8359C12.0301 11.1328 12.1875 10.9754 12.1875 10.7812Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1669_5228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollment);
export default __webpack_public_path__ + "static/media/enrollment.1cf90999b2fa178872775d259f85f4ba.svg";
export { ForwardRef as ReactComponent };